import React from "react";

// * Components
import Landing from "../../components/Landing-Section/Landing";
import Info from "../../components/Info-Section/Info";
import Carousel from "../../components/Carousel/Carousel";

// * Datas
import {
  homeObjOne,
  homeObjTwo,
  homeObjThree,
  homeProducts,
  homeObjFour,
} from "./Data";

function Home() {
  return (
    <>
      <Landing {...homeObjOne} />
      <Info {...homeObjTwo} />
      <Info {...homeObjThree} />
      <Carousel data={homeProducts} />
      <Info {...homeObjFour} />
    </>
  );
}

export default Home;
